import BaseAPI from '../base/baseApi';
import httpClient from '@/apis/base/httpclient';

class PostBatchApi extends BaseAPI {
  apiName = 'Business';
  controllerName = 'PostBatchs';

  /**
   * Thực hiện lấy dữ liệu log lỗi ghi sổ và bỏ ghi sổ
   * HQMINH 14.11.2023
   * ntduong2 20.2.2024 Lấy ra những lỗi có phát sinh để xác định mở form kết quả
   */
  async GetInfoLogPostBatch(task_id) {
    const request = {
      url: [this.getAPIUrl(), '/get_info_log_post_batch'].join(''),
      data: {task_id},
    };

    return this.getAsync(request);
  }

  /**
   * Ghi sổ/ Bỏ ghi theo lô
   * HQMINH 06.11.2023
   */
  async postBatch(payload) {
    let request = {
      url: this.getAPIUrl() + '/post_batch',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }

  /**
   * Thực hiện xóa task_log theo task_id
   * ndchien1 - 20/02/2024
   */
  async deleteTaskLog(task_id) {
    let request = {
      url: this.getAPIUrl() + '/delete_task_log',
      data: task_id,
    };
    return await httpClient.deleteAsync(request);
  }
}

export default new PostBatchApi();
